import React, { useContext, useEffect, useCallback, useMemo } from 'react';
import {
	IEditModGroupRestaurantPropertiesContext,
	EditModGroupRestaurantPropertiesContext,
} from '../../../../editModGroupRestaurantPropertiesState/editModGroupRestaurantPropertiesContext';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import Text from 'components/Text/Text';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import { RestaurantSelect } from './components/RestaurantSelect';
import { ForceDisableCheckbox } from './components/ForceDisableCheckbox';
import { ParentsList } from './components/ParentsList';
import { ModifiersMultipleSelect } from './components/ModifiersMultipleSelect';
import { BtnBlock } from './components/BtnBlock';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		setIDRestaurant,
		toggleForceDisable,
		setChildren,
		setDataForSubmit,
		changeTypeOfModalWindow,
		modGroupId,
		customerName,
		modGroupName,
		fetchedRestaurants,
		IDSelectedRestaurant,
		forceDisable,
		isPortionFlow,
		parents,
		children,
	} = useContext<IEditModGroupRestaurantPropertiesContext>(EditModGroupRestaurantPropertiesContext);
	const [form] = Form.useForm();

	const IDsSelectedModifiers = useMemo(() => children.map((child) => child.id), [children]);

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedRestaurant,
			forceDisable,
			IDsSelectedModifiers,
		});
	}, [IDSelectedRestaurant, forceDisable, IDsSelectedModifiers]);

	const submit = async () => {
		setDataForSubmit({
			restaurantId: IDSelectedRestaurant || '',
			modifierGroupId: modGroupId,
			forceDisable,
			parentIds: parents.map((parent) => parent.id),
			childIds: children.map((child) => child.id),
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleClickEditInclusive = useCallback(
		() => changeTypeOfModalWindow('editInclusive'),
		[changeTypeOfModalWindow],
	);

	const revalidateForm = form.validateFields;

	return (
		<div data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<Text
					className={style.nameOfCategory}
					translationNameSpace="form"
					translationKey={modGroupName}
					size="xxl"
					weight="bold"
					display="block"
				/>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantPropertiesHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.mainProps}>
						<FullInfoField label="customerLabel" value={customerName} useInForm={true} />
						<div />
					</div>
					<RestaurantSelect
						setIDRestaurant={setIDRestaurant}
						fetchedRestaurants={fetchedRestaurants}
						selectedRestaurantId={IDSelectedRestaurant}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="disabledStatusHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<ForceDisableCheckbox
						toggleForceDisable={toggleForceDisable}
						forceDisable={forceDisable}
						isDisabled={!IDSelectedRestaurant}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="elementsIncludeThisGroupHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<ParentsList
						parents={parents}
						onClickEditInclusive={handleClickEditInclusive}
						isDisabled={!IDSelectedRestaurant}
						isPortionFlow={isPortionFlow}
					/>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey={isPortionFlow ? 'modifiersHeading' : 'modifiersOfThisGroupHeading'}
						theme="secondary"
						size="l"
						weight="bold"
					/>
					{isPortionFlow ? (
						<Text
							translationNameSpace="form"
							translationKey="modGroupPortionDescription3"
							theme="secondary"
							size="s"
						/>
					) : (
						<ModifiersMultipleSelect
							setChildren={setChildren}
							modGroupId={modGroupId}
							restaurantId={IDSelectedRestaurant}
							IDsSelectedModifiers={IDsSelectedModifiers}
							selectedChildren={children}
						/>
					)}
				</div>
				<BtnBlock revalidateForm={revalidateForm} />
			</Form>
		</div>
	);
};
